module.exports = __webpack_public_path__ + "img/archivar.17714a65.svg";